<script>
import Multiselect from 'vue-multiselect'

export default {

    components: { Multiselect },

    props: {

    },

    data() {
        return {}
    },

    watch: {

    },

    computed: {

    },

    async mounted() {

    },

    methods: {

    }
}
</script>

<template>
    <div>
        <b-form-group
            label="Цифровой ввод"
            label-for="digital_input_params_digitals"
        >
            <b-form-input
                id="digital_input_params_digitals"
                v-model="$parent.digital_input_params.digitals"
                placeholder="Укажите цифры для ввода"
            ></b-form-input>
        </b-form-group>
    </div>
</template>
